import { apiRequest } from '@zr/utilities/api';

export async function fetchItems(url, term) {
  const [apiUrl, search] = url.split('?');
  const params = new URLSearchParams(search.replace('__term__', encodeURIComponent(term)));

  const response = await apiRequest(apiUrl, undefined, params.toString());
  const json = await response.json();

  return json;
}

export default fetchItems;
